var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 41,
    viewBox: "0 0 43 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2883_934)",
    filter: "url(#filter0_d_2883_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 32.6251C19.65 32.6251 21 31.2751 21 29.6251H15C15 31.2751 16.335 32.6251 18 32.6251ZM27 23.6251V16.1251C27 11.5201 24.54 7.66506 20.25 6.64506V5.62506C20.25 4.38006 19.245 3.37506 18 3.37506C16.755 3.37506 15.75 4.38006 15.75 5.62506V6.64506C11.445 7.66506 9 11.5051 9 16.1251V23.6251L6 26.6251V28.1251H30V26.6251L27 23.6251Z",
    fill: "url(#paint0_linear_2883_934)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2883_934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#48C1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4824 24.0068C26.4824 25.029 26.2904 25.8005 25.9062 26.3213C25.5254 26.8389 24.9443 27.0977 24.1631 27.0977C23.3949 27.0977 22.8154 26.8454 22.4248 26.3408C22.0374 25.833 21.8389 25.0827 21.8291 24.0898V22.8594C21.8291 21.8372 22.0195 21.0706 22.4004 20.5596C22.7845 20.0485 23.3688 19.793 24.1533 19.793C24.9313 19.793 25.5107 20.042 25.8916 20.54C26.2757 21.0381 26.4727 21.7835 26.4824 22.7764V24.0068ZM25.2959 22.6787C25.2959 22.0114 25.2048 21.5231 25.0225 21.2139C24.8402 20.9014 24.5505 20.7451 24.1533 20.7451C23.766 20.7451 23.4811 20.8932 23.2988 21.1895C23.1165 21.4824 23.0205 21.9414 23.0107 22.5664V24.1777C23.0107 24.8418 23.1035 25.3366 23.2891 25.6621C23.4746 25.9876 23.766 26.1504 24.1631 26.1504C24.5439 26.1504 24.8255 26.0007 25.0078 25.7012C25.1901 25.3984 25.2861 24.9264 25.2959 24.2852V22.6787ZM32.3125 27H27.5322V26.1846L29.9004 23.6016C30.2422 23.2207 30.4847 22.9033 30.6279 22.6494C30.7744 22.3923 30.8477 22.1351 30.8477 21.8779C30.8477 21.5394 30.7516 21.266 30.5596 21.0576C30.3708 20.8493 30.1152 20.7451 29.793 20.7451C29.4089 20.7451 29.111 20.8623 28.8994 21.0967C28.6878 21.3311 28.582 21.6517 28.582 22.0586H27.3955C27.3955 21.6257 27.4932 21.2367 27.6885 20.8916C27.887 20.5433 28.1686 20.2731 28.5332 20.0811C28.901 19.889 29.3242 19.793 29.8027 19.793C30.4928 19.793 31.0365 19.9671 31.4336 20.3154C31.834 20.6605 32.0342 21.139 32.0342 21.751C32.0342 22.1058 31.9333 22.4785 31.7314 22.8691C31.5329 23.2565 31.2057 23.6976 30.75 24.1924L29.0117 26.0527H32.3125V27Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2883_934",
    x: -1,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2883_934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2883_934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2883_934",
    x: 14,
    y: 15,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2883_934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2883_934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2883_934",
    x1: 6,
    y1: 3.37506,
    x2: 9.78838,
    y2: 35.3757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E4D6B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2883_934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.f8de419e.svg";
export { ForwardRef as ReactComponent };